import { Reducer } from 'redux';
import { produce } from 'immer';
import { ActionTypes, IOrdersState } from './types';
import { IOrderDetailed } from '../../../types/orders';

const INITIAL_STATE: IOrdersState = {
  openOrders: [],
  incompleteOrders: [],
  finishedOrders: [],
};

const orders: Reducer<IOrdersState> = (state = INITIAL_STATE, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case ActionTypes.getOrdersSuccess: {
        const { input } = action.payload;

        if (input.status === 'FINALIZADA') {
          draft.finishedOrders = input.orders;
        } else {
          const statusTypes = input.status.split(',');
          const openOrders = input.orders.filter(
            (order: IOrderDetailed) => order.status === 'ABERTA',
          );
          const incompleteOrders = input.orders.filter(
            (order: IOrderDetailed) => order.status === 'INCOMPLETA',
          );
          draft.openOrders = openOrders;
          draft.incompleteOrders = incompleteOrders;

          if (statusTypes.includes('FINALIZADA')) {
            const finishedOrders = input.orders.filter(
              (order: IOrderDetailed) => order.status === 'FINALIZADA',
            );
            draft.finishedOrders = finishedOrders;
          }
        }
        return draft;
      }
      default: {
        return draft;
      }
    }
  });
};

export default orders;
